import { NgClass, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { DsTitleSize } from '@design-system/ds-title/types/ds-title-size.type';
import { DsTitleWeight } from '@design-system/ds-title/types/ds-title-weight.type';
import { DsTitleFontSettings } from '@design-system/ds-title/interfaces/ds-title-font-settings.interface';

@Component({
  selector: 'ds-title',
  standalone: true,
  imports: [NgIf, NgClass],
  templateUrl: './ds-title.component.html',
  styleUrls: ['./ds-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DsTitleComponent {
  /**
   * Controls typography size variant.
   *
   * @default 'md'
   */
  @Input() size: DsTitleSize = 'md';

  /**
   * Controls typography weight variant.
   *
   * @default 'regular'
   */
  @Input() weight: DsTitleWeight = 'regular';

  /**
   * Optional plain text content.
   * If not provided, projected content is rendered.
   */
  @Input() text: string | null = null;

  /**
   * Optional color override for title.
   * If not provided, default title color is used.
   */
  @Input() color: string | null = null;

  /**
   * Optional uncommon typography overrides.
   */
  @Input() fontSettings: DsTitleFontSettings | null = null;
}
